export default __webpack_public_path__ + "static/media/Collab9.14f91343.png";